// True only where a pointer can really hover (a mouse or trackpad). Phones
// fire mouseenter on tap and never the leave, so hover styles set from JS
// stick and an option looks picked. Guard JS hover handlers with this.
export const canHover = () =>
  typeof window !== "undefined" && !!window.matchMedia?.("(hover: hover)").matches;
